<template>
    <div class="legend-wrapper">
        <div v-if="!minimized" class="custom-legend">
            <div class="legend-header">
                <span>Legenda de CNAEs</span>
            </div>
            <ul class="legend-list">
                <li>
                    <span class="color-box green"></span> Permitido
                </li>
                <li>
                    <span class="color-box yellow"></span> Permmissível
                </li>
                <li>
                    <span class="color-box red"></span> Proibido
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

const minimized = ref(false)
</script>

<style scoped>
.custom-legend {
    width: 150px;
    background: white;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    font-family: sans-serif;
    font-size: 13px;
    border: 1px solid #ccc;
}

.legend-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    padding: 6px 10px;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
}

.legend-list {
    list-style: none;
    margin: 0;
    padding: 8px 10px 10px;
}

.legend-list li {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
}

.color-box {
    width: 14px;
    height: 14px;
    border: 1px solid #333;
    margin-right: 8px;
    flex-shrink: 0;
}

.green {
    background-color: green;
}

.yellow {
    background-color: yellow;
}

.red {
    background-color: red;
}
</style>
